//components
import { ConceptDisplayDropDown } from '../../display_front/ConceptDisplayDropDown.js';
import { pluralConcepts } from '../../functions/pluralConcepts/pluralConcepts.js';

import styles from './removeButtonStyles.css';
/*this component creates the presentation of each concept in the editor 
Props:
	concept: (string) the concept being displayed
	frontend_pre_fix: (string) any prefix to the title
	more_info_output: (object) settings to display
	selected_concepts: (array) the data to present 
	onClick: (function) to remove a concept
	isSelected: (bool) if the block is selected
	defaultOpen: (bool) if the dropdown should defalut to open
*/
export function ConceptEditingBlock (props) {
	//variables to use
	let { 
			concept, 
			isSelected, 
			frontend_pre_fix, 
			more_info_output, 
			onClick, 
			selected_concepts, 
			defaultOpen,  
		} = props;

	//if concepts are not selected return error message - need to check for array to avoid object being passed
	if ( selected_concepts == undefined || !Array.isArray(selected_concepts) || selected_concepts.length < 1) {
		return <p>No {pluralConcepts(concept)} added yet. </p>;
	}

	return selected_concepts.map((item) => {
		return <div> 
			{ isSelected  === true ? 
				<button className={styles.remove} onClick={onClick} name={item['id_'+concept]} >
					<span className={styles.removeX}>✘</span> remove this {concept}
				</button>
				:null
			}
			<ConceptDisplayDropDown 
				data={item}
				concept={concept}
				frontend_pre_fix={frontend_pre_fix}
				more_info_output={more_info_output}
				defaultOpen={defaultOpen}
			/>
		</div>;
	});
}